/* MARMOT: продуктова страница (Порция #237). Vanilla, defer, без библиотеки.
   - Галерия: клик върху миниатюра сменя голямата сцена.
   - „Прочети откъс": отваря модал с Heyzine iframe (src се вписва при отваряне).
   - Количество: − / + степер; обновява прогреса за безплатна доставка.
   - Лепната долна лента: position:fixed + spacer (НЕ sticky – Lumia убива sticky).
     Показва се, след като купи-зоната излезе от екрана нагоре. */
(function () {
  'use strict';

  var root = document.querySelector('[data-marmot-pdp]');
  if (!root) return;

  /* Preview на типа корица без метаполе: ?mockup=soft|rounded|hard */
  try {
    var mk = new URLSearchParams(window.location.search).get('mockup');
    if (mk && /^(soft|rounded|hard)$/.test(mk)) {
      var cov = root.querySelector('.marmot-pdp__frame--cover');
      if (cov) cov.className = cov.className.replace(/is-mockup-\w+/, 'is-mockup-' + mk);
    }
  } catch (e) {}

  /* Изрязване на прозрачното поле около корицата (soft/rounded/hard).
     Файловете са квадратни с прозрачни полета; за реално заоблени ъгли трябва
     корицата да пълни рамката. Откриваме границите ѝ през алфа-канала (canvas),
     напасваме я да пълни рамката → CSS заобля реалните ѝ ъгли (overflow:hidden).
     Ползваме отделен crossorigin probe, за да не рискуваме показвания образ. */
  (function trimCover() {
    var frame = root.querySelector('.marmot-pdp__frame--cover');
    if (!frame || !/is-mockup-(soft|rounded|hard)/.test(frame.className)) return;
    var img = frame.querySelector('.marmot-pdp__media');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var w = probe.naturalWidth, h = probe.naturalHeight;
      if (!w || !h) return;
      var cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      var cx = cv.getContext('2d', { willReadFrequently: true });
      cx.drawImage(probe, 0, 0);
      var data;
      try { data = cx.getImageData(0, 0, w, h).data; } catch (e) { return; }
      var minX = w, minY = h, maxX = 0, maxY = 0, found = false, T = 12;
      for (var y = 0; y < h; y++) {
        var row = y * w;
        for (var x = 0; x < w; x++) {
          if (data[(row + x) * 4 + 3] > T) {
            found = true;
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (!found) return;
      var cw = maxX - minX + 1, ch = maxY - minY + 1;
      var s = frame.style;
      s.setProperty('--cov-ar', (cw / ch).toFixed(4));
      s.setProperty('--cov-w', (w / cw * 100).toFixed(3) + '%');
      s.setProperty('--cov-h', (h / ch * 100).toFixed(3) + '%');
      s.setProperty('--cov-x', '-' + (minX / cw * 100).toFixed(3) + '%');
      s.setProperty('--cov-y', '-' + (minY / ch * 100).toFixed(3) + '%');
      frame.classList.add('is-trimmed');
    };
    probe.onerror = function () { /* CORS/зареждане – оставяме fallback вида */ };
    probe.src = src;
  })();

  /* ── Галерия ──────────────────────────────────────────── */
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
  function showSlide(idx) {
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
    thumbs.forEach(function (t) {
      t.classList.toggle('is-active', parseInt(t.getAttribute('data-pdp-thumb'), 10) === idx);
    });
  }
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      showSlide(parseInt(t.getAttribute('data-pdp-thumb'), 10) || 0);
    });
  });

  /* ── Количество + прогрес за доставка ─────────────────── */
  var priceEl = root.querySelector('[data-pdp-price]');
  var shipEl = root.querySelector('[data-pdp-ship]');
  var qtyInput = root.querySelector('[data-pdp-qty-input]');
  var variantSel = root.querySelector('[data-pdp-variant]');

  function unitCents() {
    if (variantSel) {
      var opt = variantSel.options[variantSel.selectedIndex];
      if (opt && opt.getAttribute('data-cents')) return parseInt(opt.getAttribute('data-cents'), 10) || 0;
    }
    return priceEl ? (parseInt(priceEl.getAttribute('data-unit-cents'), 10) || 0) : 0;
  }
  function qty() {
    var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return (isNaN(q) || q < 1) ? 1 : q;
  }
  function updateShip() {
    if (!shipEl) return;
    var goal = parseInt(shipEl.getAttribute('data-goal-cents'), 10) || 3000;
    var line = unitCents() * qty();
    var pct = Math.min(100, Math.round((line / goal) * 100));
    var fill = shipEl.querySelector('[data-pdp-ship-fill]');
    var pctEl = shipEl.querySelector('[data-pdp-ship-pct]');
    var lblEl = shipEl.querySelector('[data-pdp-ship-label]');
    if (fill) fill.style.width = pct + '%';
    if (pctEl) pctEl.textContent = pct + '%';
    if (lblEl) lblEl.textContent = pct >= 100 ? 'Имаш безплатна доставка 🎉' : 'Добави още за безплатна доставка';
  }
  var dec = root.querySelector('[data-pdp-qty-dec]');
  var inc = root.querySelector('[data-pdp-qty-inc]');
  if (dec) dec.addEventListener('click', function () {
    if (qtyInput) { qtyInput.value = Math.max(1, qty() - 1); updateShip(); }
  });
  if (inc) inc.addEventListener('click', function () {
    if (qtyInput) { qtyInput.value = qty() + 1; updateShip(); }
  });
  if (qtyInput) qtyInput.addEventListener('input', updateShip);
  if (variantSel) variantSel.addEventListener('change', updateShip);

  /* ── Лепната долна лента: fixed + spacer ──────────────── */
  var bar = document.querySelector('[data-pdp-bar]');
  var buy = root.querySelector('[data-pdp-buy]');
  var spacer = null;
  if (bar && buy) {
    bar.hidden = false;

    function ensureSpacer() {
      if (spacer) return;
      spacer = document.createElement('div');
      spacer.setAttribute('data-pdp-bar-spacer', '');
      spacer.style.height = bar.offsetHeight + 'px';
      bar.parentNode.insertBefore(spacer, bar);
    }
    function toggleBar() {
      var r = buy.getBoundingClientRect();
      // Показвай, след като дъното на купи-зоната мине над екрана.
      var show = r.bottom < 90;
      if (show) { ensureSpacer(); }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', toggleBar, { passive: true });
    window.addEventListener('resize', toggleBar);
    toggleBar();

    // Бутонът в лентата = submit на основната форма.
    var barAdd = bar.querySelector('[data-pdp-bar-add]');
    var form = root.querySelector('[data-pdp-form]');
    if (barAdd && form) {
      barAdd.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* ── Модал „Прочети откъс" ────────────────────────────── */
  var modal = document.querySelector('[data-pdp-modal]');
  var openBtn = root.querySelector('[data-pdp-excerpt-open]');
  if (modal && openBtn) {
    var iframe = modal.querySelector('[data-pdp-flip-src]');
    var lastFocus = null;

    function openModal() {
      lastFocus = document.activeElement;
      if (iframe && !iframe.getAttribute('src')) {
        iframe.setAttribute('src', iframe.getAttribute('data-pdp-flip-src'));
      }
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('[data-pdp-modal-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openBtn.addEventListener('click', openModal);
    modal.querySelectorAll('[data-pdp-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  updateShip();
})();
